<script lang="ts">
  import Loading from '../../../etc/loader.svelte';
  import RepositoryFactory, { CONTRACT } from '../../../repositories/RepositoryFactory';
  import type { GetContractResult } from '../../../repositories/contract';
  import { loginUser } from '../../../components/auth/LoginUser';

  let contract: GetContractResult,
    pageStatus = 'INPUT',
    promise = getApi();

  // 確認画面
  function onConfirm() {
    pageStatus = 'CONFIRM';
  }
  // 完了画面
  function onComplete() {
    pageStatus = 'COMPLETE';
  }
  // 入力画面
  function onBack() {
    pageStatus = 'INPUT';
  }

  function displayErrorAlert(status: number) {
    if (status === 403) {
      alert('セッションが切れました。再度ログインしてください。');
      loginUser.logout();
      location.reload();
    } else {
      alert('エラーが発生しました。再度やり直してください。');
    }
  }

  async function getApi() {
    const contractRepository = RepositoryFactory[CONTRACT];
    await contractRepository
      .getContract()
      .then((res) => {
        if (!res) {
          throw new Error();
        }
        contract = res;
      })
      .catch((error) => {
        displayErrorAlert(error.response.status);
      });
    return contract;
  }

  function doPost() {
    if (contract.contractStatusCode === 'TERMINATED') {
      alert('解約済みのため解約できません');
      return;
    }

    const contractRepository = RepositoryFactory[CONTRACT];
    contractRepository
      .terminateContractRequest({
        contractId: contract.contractId
      })
      .then((res) => {
        onComplete();
      })
      .catch((error) => {
        displayErrorAlert(error.response.status);
      });
  }
</script>

{#await promise}
  <Loading />
{:then contract}
  <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
    <div class="flex flex-col">
      {#if pageStatus === 'INPUT'}
        <div class="flex-1 mb-6">
          <div class="min-w-full">
            ご契約いただいている回線サービスを解約します。<br />
            注意事項等をご確認いただき、「手続きへ」を押してください。<br />
            後ほど、カスタマーセンターからご登録のメールアドレスへご連絡させていただきます。
          </div>
        </div>
      {:else if pageStatus === 'CONFIRM'}
        <div class="flex-1 mb-4">
          <div class="inline-flex justify-items-center items-center min-w-full">
            <div>
              解約の申し込みをさせていただきます。<br />
              この時点ではお手続きは完了していません。<br />
              お送りするメールの内容を必ずご確認ください。
            </div>
          </div>
        </div>
      {:else}
        <div class="flex-1 mb-4">
          <div class="inline-flex justify-items-center items-center min-w-full p-6">
            <span class="">解約依頼が完了しました。</span>
          </div>
        </div>
      {/if}

      <div class="flex-1 mb-10">
        <div class="shadow rounded bg-gray-200 p-4 text-sm">
          <div>
            ※この時点ではお手続きは完了しません。<br />
            ※後ほど、カスタマーセンターからご登録のメールアドレスへご連絡させていただきますので内容を必ずご確認ください。
            <br />
            ※お問い合わせ状況により、ご連絡に数日お時間を要する場合があります。
          </div>
          <div class="mt-3">
            ※お問い合わせは以下からご連絡いただきますようお願いします。
            <br />
            URL：
            <a href="https://bb.unext.co.jp/contact" rel="noopener noreferrer" target="_blank">
              https://bb.unext.co.jp/contact
            </a>
          </div>
        </div>
      </div>

      {#if pageStatus === 'CONFIRM'}
        <div class="flex-1 mt-8">
          <div class="flex flex-col justify-items-center items-center">
            <div class="flex-1">
              <button on:click|once={onBack} class="button-primary"> 戻る </button>
              <button on:click|once={doPost} class="button-primary"> 完了 </button>
            </div>
          </div>
        </div>
      {:else if pageStatus === 'INPUT'}
        <div class="flex-1">
          <div class="flex flex-col justify-items-center items-center">
            <div class="flex-1">
              <button
                on:click|once={onConfirm}
                class="button-primary"
                disabled={contract.contractStatusCode !== 'RUNNING'}
              >
                手続きへ
              </button>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
{/await}

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
